import { BotStatus } from '../interfaces';
import { Button, Col, Flex, Form, Input, Progress, Row, Select, Spin, Switch, Tag, message, notification } from 'antd';
import Axios from "axios";
import { Space, Table } from 'antd';
import type { ColumnsType, TableProps } from 'antd/es/table';
import { CloseCircleFilled, CheckCircleFilled, DownloadOutlined, LoadingOutlined, PlayCircleOutlined, EditFilled, PlusOutlined } from '@ant-design/icons';
// @ts-ignore
import React, { useEffect, useState, useRef } from "react";
import Typography from 'antd/es/typography/Typography';
interface StatusData {
  id?: number | null;
  enseigne: string;
  datebegin: string;
  dateend: string;
  message: string;
  type: string;
  timeout: number;
}

interface PageData {
  key: string;
  id?: number | null;
  enseigne: string;
  datebegin?: string;
  dateend?: string;
  message?: string;
  type?: string;
  status?: BotStatus;
  timeout?: number;
}
interface StoreData {
  id: string;
  raison_sociale: string;
  address_full: string;
  street: string;
  postal_code: string;
  city: string;
  phone: string;
  email: string;
  website: string;
  siret: string;
  sign: string;
  comment: string;
  active: boolean;
  created_date: string;
  updated_date: string;
  status: string;
  reference_id: string;
  prod: boolean;
}

interface AddBotData {
  enseigne: string;
  type: string;
  dataJson?: string;
}


export function MsBots({ setTab }: { setTab: (tab: string, enseigne?: string) => void }) {

  const [playSound, setPlaySound] = useState(false);
  const [data, setData] = useState<PageData[]>([]);
  const [enseigneFilters, setEnseigneFilters] = useState<{ text: string; value: string }[]>([]);
  const intervalRef = useRef<number | null>(null);

  function updateLinesBot(sign: string, rowKey: string) {
    const payload = { "sign": sign };
    Axios.post('/ms/bots/status/line', payload)
      .then((response) => {
        setData(currentData => sortBotRows(currentData.map(row => row.key === rowKey ? {
          ...row,
          dateend: null,
          message: "",
          ...response.data,
          key: row.key,
        } : row)));
      });
  }

  async function launchPrefectProcess(enseigne: string, rowKey: string) {
    setData(currentData => currentData.map(row => row.key === rowKey ? { ...row, status: BotStatus.Running } : row));
    if (playSound) {
      const audio = new Audio('/assets/files/action.mp3');
      try {
        audio.play();
      } catch (error) {
        console.log("Erreur lors de la lecture de l'audio:", error);
      }
    }
    await Axios.post('/ms/bots/upsert', { "enseigne": enseigne, "datebegin": new Date() }),
      (error: any) => {
        console.log("error");
        console.log(error);
      }
    updateLinesBot(enseigne, rowKey);
    await Axios.post("/ms/bots/prefect/" + enseigne + "/scrapping"),
      (error: any) => {
        console.log("error");
        console.log(error);
      }
  }

  /**
   * Télécharge et organise les données des magasins selon le secteur et l'enseigne.
   * @param sector Le secteur cible.
   * @param sign L'enseigne cible.
   * @param date La date optionnelle pour le filtrage.
   */
  async function getAllStores(enseigne: string, date?: string) {
    Axios.post('/ms/bots/sign/download', { enseigne: enseigne }, { responseType: 'json' })
      .then((response) => {
        const responseJson = JSON.stringify(response.data);
        let jsonData: StoreData[] = JSON.parse(responseJson).map((item: StoreData): StoreData => ({
          id: item.id,
          raison_sociale: item.raison_sociale || '',
          address_full: item.address_full || '',
          street: item.street || '',
          postal_code: item.postal_code || '',
          city: item.city || '',
          phone: item.phone || '',
          email: item.email || '',
          website: item.website || '',
          siret: item.siret || '',
          sign: item.sign,
          comment: item.comment || '',
          active: item.active,
          created_date: item.created_date,
          updated_date: item.updated_date,
          status: item.status || '',
          reference_id: item.reference_id || '',
          prod: item.prod
        }));

        jsonData = organizeData(jsonData);
        const headers = Object.keys(jsonData[0]);
        const csvData = [
          headers.join(';'),
          ...jsonData.map((row: any) => headers.map((header: any) => `${row[header]}`.replace(/;/g, ',')).join(';'))
        ].join('\n');

        const csvBlob = new Blob([csvData], { type: 'text/csv' });

        const downloadUrl = window.URL.createObjectURL(csvBlob);
        const link = document.createElement('a');

        link.href = downloadUrl;
        const formattedDate = date ? new Date(date).toISOString().slice(0, 10).replace(/-/g, '') : '';
        const fileName = formattedDate ? `${enseigne} ${formattedDate}.csv` : `${enseigne}.csv`;

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      }, (error) => {
        console.log("error");
        console.log(error);
      })
  }


  /**
   * Organise les données : les lignes avec un reference_id sont précédé de la ligne original.
   * @param data Les données à organiser.
   * @returns Les données organisées.
   */
  function organizeData(data: StoreData[]): StoreData[] {
    const grouped: Map<string, StoreData[]> = new Map();

    // Group entries by reference_id
    data.forEach(item => {
      const key = item.reference_id || item.id;
      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key)?.push(item);
    });

    // Create an array to hold the organized data
    const organizedData: StoreData[] = [];

    // Sort groups and arrange original before its modifications
    grouped.forEach((items, key) => {
      const original = items.find(item => item.id === key);
      if (original) {
        organizedData.push(original);
      }
      items.forEach(item => {
        if (item.id !== key) {
          organizedData.push(item);
        }
      });
    });

    return organizedData;
  }

  useEffect(() => {
    Promise.all([
      Axios.get('/ms/bots/status')
    ]).then(([listResponse]) => {
      const statusData: StatusData[] = listResponse.data;

      const mergedData: PageData[] = statusData.map((item, index) => ({
        enseigne: item.enseigne,
        id: item.id,
        key: item.id != null ? String(item.id) : `${item.enseigne}__${index}`,
        datebegin: item.datebegin,
        dateend: item.dateend,
        message: item.message,
        type: item.type,
        timeout: item.timeout,
      }));


      setData(sortBotRows(mergedData));
      const enseignes = new Set<string>();
      mergedData.forEach(item => {
        enseignes.add(item.enseigne);
      });
      setEnseigneFilters(Array.from(enseignes).map(name => ({ text: name, value: name })));
    }).catch(error => {
      console.error('Erreur lors du chargement des données', error);
    });
  }, []);

  /**
   * Rafraîchit les données de statut des robots actifs.
   */
  const refreshStatusData = async () => {
    if (data.filter(row => row.status === BotStatus.Running).length > 0) {
      try {
        const activeRobotsData = data.filter(row => row.status === BotStatus.Running).map((row) => row.enseigne);
        const response = await Axios.post('/ms/bots/status/refresh', { robots: activeRobotsData });
        const newData: StatusData[] = response.data;
        setData(currentData => sortBotRows(currentData.map(row => {
          const newRow = row.id != null
            ? newData.find(status => status.id === row.id)
            : newData.find(status => status.enseigne === row.enseigne);
          if (newRow) {
            const status = newRow.dateend
              ? (newRow.message?.includes('Error') ? BotStatus.Error : BotStatus.Success)
              : BotStatus.Running;
            return { ...row, ...newRow, status, key: row.key };
          }
          return row;
        })));
      } catch (error) {
        console.error('Erreur lors de la récupération des données', error);
      }
    }
  };

  useEffect(() => {
    if (data.filter(row => row.status === BotStatus.Running).length > 0 && intervalRef.current === null) {
      intervalRef.current = setInterval(refreshStatusData, 3000);
    } else if (data.filter(row => row.status === BotStatus.Running).length === 0 && intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    return () => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [data.filter(row => row.status === BotStatus.Running).length]);

  /**
   * Formate une chaîne de date en format jour/mois/année heures:minutes:secondes.
   * @param dateString La chaîne de date à formater.
   * @returns La date formatée ou une chaîne vide si la date n'est pas valide.
   */
  function formatDate(dateString: string) {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }


  const focusFilterSearchInput = () => {
    setTimeout(() => {
      document
        .querySelector<HTMLInputElement>('.ant-table-filter-dropdown .ant-table-filter-dropdown-search-input input')
        ?.focus();
    }, 0);
  };

  const columns: ColumnsType<PageData> = [
    {
      title: 'Enseigne',
      dataIndex: 'enseigne',
      key: 'enseigne',
      filters: enseigneFilters,
      onFilter: (value, record) => record.enseigne === String(value),
      filterSearch: (input, filter) => String(filter.text ?? '').toLowerCase().includes(input.trim().toLowerCase()),
      onFilterDropdownOpenChange: (open) => {
        if (open) {
          focusFilterSearchInput();
        }
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record: PageData) => {

        return (
          <Col span={12} >
            <Space direction="vertical">
              {record.type == "manual" ? (
                <Button icon={<EditFilled />} onClick={() => {
                  setTab("2", record.enseigne);

                }} disabled={record.status === BotStatus.Running} >Modifier les infos</Button>
              ) : record.type === 'siren' ? (
                <Button icon={<PlayCircleOutlined />} onClick={() => setTab("2", record.enseigne)} >
                  Récupérer les sirets
                </Button>
              ) : (
                <Button
                  icon={<PlayCircleOutlined />}
                  onClick={() => launchPrefectProcess(record.enseigne, record.key)}
                  disabled={record.status === BotStatus.Running}  // Ajouter isActive à la condition de désactivation
                >
                  Lancer
                </Button>
              )}
              <Button icon={<DownloadOutlined />} onClick={() => record.dateend ? getAllStores(record.enseigne, record.dateend) : getAllStores(record.enseigne)}>
                .xls
              </Button>
            </Space>
          </Col>
        );
      },
    },
    {
      title: 'Dernier appel ⏰',
      dataIndex: 'datebegin',
      key: 'datebegin',
      render: (_, record: PageData) => {
        return <Col>
          <Space direction="vertical">
            <Tag color="grey">{record.datebegin ? ("Lancé le : " + formatDate(record.datebegin)) : 'Pas encore lancé'}</Tag>

            {record.status === BotStatus.NotLaunched ? <Tag color="blue">Pas encore lancé</Tag> :
              record.dateend && record.status === BotStatus.Success ?
                <Tag color="green"><Flex align="center" gap={8}><CheckCircleFilled />Terminé le : {formatDate(record.dateend)}</Flex></Tag> :
                record.status === BotStatus.Running ?
                  <Tag style={{ padding: '10px' }} color="blue"><Flex align="center" gap={8}><Spin indicator={<LoadingOutlined />} />En cours</Flex></Tag> :
                  record.status === BotStatus.Timeout ?
                    <Tag color="red"><Flex align="center" gap={8}><CloseCircleFilled />Timeout</Flex></Tag> :
                    <Tag color="red">
                      <Flex align="center" gap={8}>
                        <CloseCircleFilled />
                        <span>En erreur{record.dateend ? ' le : ' + formatDate(record.dateend) : ''}</span>
                      </Flex>
                    </Tag>}
          </Space>

        </Col>
      }



    },
    {
      title: 'Type de robot',
      dataIndex: 'type',
      key: 'type'
    },
    {
      title: 'Message 🤖',
      dataIndex: 'message',
      key: 'message',
      render: text => {
        if (typeof text === 'string') {
          const truncatedText = text.length > 80 ? text.substring(0, 80) + '...' : text;
          if (text.startsWith('OK')) {
            return <span style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: text }} />;
          } else {
            return <span style={{ color: 'red' }} dangerouslySetInnerHTML={{ __html: truncatedText }} />;
          }
        } else {
          return null;
        }
      }
    },
  ];

  const onChange: TableProps<PageData>['onChange'] = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  };


  const [showForm, setShowForm] = useState(false);


  /**
   * Gère la soumission du formulaire pour lancer un robot avec des paramètres spécifiques.
   * @param values Les valeurs du formulaire incluant secteur, enseigne et optionnellement SIRET.
   */
  const handleFormSubmit = (values: { sign: any; type: string, siren?: string }) => {
    let dataPost: AddBotData;
    dataPost = { "enseigne": values.sign, "type": values.type }
    if (values.siren) {
      dataPost.dataJson = JSON.stringify({ "siren": values.siren });
    }

    Axios.post('/ms/bots/add', dataPost)
      .then(response => {
        message.success('Robot ajouté avec succès');
        setShowForm(false); // Cacher le formulaire après l'envoi
        const toAdd: PageData = { enseigne: values.sign, key: `new-${Date.now()}-${values.sign}`, datebegin: undefined, dateend: undefined, message: undefined, type: values.type, status: BotStatus.NotLaunched, timeout: undefined };
        const newData = [toAdd, ...data];
        setData(sortBotRows(newData));
      })
      .catch(error => {
        message.error('Erreur lors de l\'ajout du robot');
      });

  };

  return (
    <div style={{ position: 'relative' }}>
      <Button onClick={() => setShowForm(!showForm)} style={{ margin: 8 }}>
        Ajouter un robot
      </Button>
      {showForm && <FormAddBot handleFormSubmit={handleFormSubmit} setShowForm={setShowForm} />}
      <Button
        type="primary"
        onClick={() => setPlaySound(!playSound)}
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          backgroundColor: 'transparent',
          border: '1px solid transparent',
          color: 'transparent',
          boxShadow: 'none',
          padding: 0,
          margin: 0,
          width: 50,
          height: 50,
          zIndex: 1000,
          cursor: 'pointer'
        }}
      >
        {playSound ? 'ON' : 'OFF'}
      </Button>
      <Table rowKey="key" columns={columns} dataSource={data} onChange={onChange} pagination={false} />
    </div>

  )
}

function getStatus(row: PageData): BotStatus {
  if (!row.datebegin) {
    return BotStatus.NotLaunched;
  }
  if (row.datebegin && !row.dateend) {
    if (Date.now() - new Date(row.datebegin).getTime() > (row.timeout || 86400) * 1000) {
      return BotStatus.Timeout;
    } else if (row.message && row.message.includes('Error :')) {
      return BotStatus.Error;
    } else {
      return BotStatus.Running;
    }
  }
  if (row.message && row.message.includes('Error :')) {
    return BotStatus.Error;
  }
  return BotStatus.Success;
}

function getLaunchTime(row: PageData): number {
  if (!row.datebegin) {
    return 0;
  }
  const time = new Date(row.datebegin).getTime();
  return isNaN(time) ? 0 : time;
}

function compareBots(a: PageData, b: PageData): number {
  const aRunning = getStatus(a) === BotStatus.Running;
  const bRunning = getStatus(b) === BotStatus.Running;
  if (aRunning !== bRunning) {
    return aRunning ? -1 : 1;
  }
  const aLaunched = !!a.datebegin;
  const bLaunched = !!b.datebegin;
  if (aLaunched !== bLaunched) {
    return aLaunched ? 1 : -1;
  }
  return getLaunchTime(b) - getLaunchTime(a);
}

function sortBotRows(rows: PageData[]): PageData[] {
  return [...rows]
    .map(row => ({ ...row, status: getStatus(row) }))
    .sort(compareBots);
}

function FormAddBot({ handleFormSubmit, setShowForm }: { handleFormSubmit: (values: { sign: any; type: string, siren?: string }) => void, setShowForm: (show: boolean) => void }) {
  const [form] = Form.useForm();
  const botType = Form.useWatch('type', form);
  return (
    <Form form={form} layout="inline" onFinish={handleFormSubmit} style={{ marginBottom: 20 }} initialValues={{ type: 'scrapping python' }}>
      <Form.Item
        name="sign"
        label="Enseigne"
        rules={[{ required: true, message: 'Veuillez entrer l\'enseigne !' }]}
      >
        <Input placeholder="Enseigne" />
      </Form.Item>
      <Form.Item name="type" label="Type" rules={[{ required: true, message: 'Veuillez entrer le type !' }]}>
        <Select style={{ width: 200 }} placeholder="Type" options={[{ label: 'Manuel', value: 'manual' }, { label: 'Scrapping Python', value: 'scrapping python' }, { label: 'Intégré (sirens)', value: 'siren' }]} />
      </Form.Item>
      {botType === 'siren' && (
        <Col>
          <Form.Item name="siren" label="Siren" rules={[{ required: true, message: 'Veuillez entrer le siren !' }]}>
            <Input placeholder="Siren" />
          </Form.Item>
          <Typography>Si plusieurs sirens, séparer par des points-virgules</Typography>
        </Col>
      )}
      <Button icon={<PlusOutlined />} type="primary" htmlType="submit" style={{ marginLeft: 8, marginBlock: 'auto' }}>
        Ajouter
      </Button>
      <Button type="default" onClick={() => setShowForm(false)} style={{ marginLeft: 8, marginBlock: 'auto' }}>
        Annuler
      </Button>
    </Form>
  )
}